import React, { useState, useEffect } from 'react';
import './esqueci_senha.css';
import { Link, useNavigate } from 'react-router-dom';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';

function EsqueciSenha() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isEmailSent, setIsEmailSent] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isEmailSent) {
      const timer = setTimeout(() => {
        navigate('/login');
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [isEmailSent, navigate]);

  const handlePasswordReset = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        `https://rvensino.com.br/get.php?action=enviarEmailRedefinicaoSenha&email=${email}`
      );

      const textResponse = await response.text(); // Obtém a resposta como texto bruto

      let data;

      try {
        // Tenta parsear a resposta como JSON
        data = JSON.parse(textResponse);
      } catch (error) {
        console.warn('Resposta não é um JSON válido. Usando texto bruto.');
        data = { message: textResponse }; // Trata o texto bruto como uma mensagem
      }

      // Exibe a mensagem retornada no campo "message"
      if (data?.status === 0) {
        setMessage(data.message);
        setIsEmailSent(true);
      } else {
        setMessage(data.message || 'Erro desconhecido. Contate o suporte.');
      }
    } catch (error) {
      console.error('Erro ao enviar email de recuperação:', error);
      setMessage('Um erro ocorreu. Tente novamente mais tarde.');
    }
  };

  return (
    <div className="page-container login">
      <div className="login-container">
        <form onSubmit={handlePasswordReset} className='form-forgot-password'>
          <div className="arrow-back cadastro">
            <Link to="/login" className="no-link-style">
              <ArrowBackOutlinedIcon style={{ color: '#000', fontSize: 35 }} className='sidebar-icon custom-arrow-icon' />
            </Link>
          </div>
          <Link to="/login" className="no-link-style">
            <img src="https://rvensino.com.br/230616_RV_logo_principal_positivo-cor.png" alt="Logo" className="login-logo" />
          </Link>
          <input
            type="text"
            placeholder="Email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button className="button" type="submit">
            Enviar email de recuperação
          </button>
          {message && <p className="message">{message}</p>}
        </form>
      </div>
    </div>
  );
}

export default EsqueciSenha;
